<template>
  <div class="app-points-container">
    <div class="welcome-text">
      <h1>
        Seja bem vindo ao <br />
        nosso Clube!
      </h1>
    </div>
    <div class="auth-content">
      <login-form v-if="!isAuthenticated"></login-form>
      <user-points v-if="isAuthenticated"></user-points>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/LandingPage/LoginForm.vue';
import UserPoints from '@/components/LandingPage/UserPoints.vue';

import TermVerificationService from '@/services/term-verification.service';
import ClientService from '@/services/client.service';
import AppTermVerificationModal from '@/components/Modal/TermVerificationModal.vue';
import AppActiveCardModal from '@/components/Modal/AcitveCardModal.vue';
import { AUTH_LOGOUT } from '@/store/actions/auth';

export default {
  name: 'app-points-container',
  components: {
    LoginForm,
    UserPoints,
  },
  data() {
    return {
      activeCardModal: null,
    };
  },
  methods: {
    showTermModal() {
      this.$buefy.modal.open({
        parent: this,
        component: AppTermVerificationModal,
        trapFocus: true,
        hasModalCard: true,
        onCancel: this.onCancel,
      });
    },
    onCancel() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.activeCardModal.close();
        this.$route.path !== '/' && this.$router.push('/');
      });
    },
    showCardDialog() {
      this.activeCardModal = this.$buefy.modal.open({
        parent: this,
        props: { isLogin: true },
        component: AppActiveCardModal,
        trapFocus: true,
        hasModalCard: true,
      });
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  watch: {
    isAuthenticated(newValue) {
      if (newValue) {
        TermVerificationService.get().then((response) => {
          if (!response.data) {
            setTimeout(() => {
              this.showTermModal();
            }, 500);
          }
        });

        ClientService.verifyCardStatus().then(({ data }) => {
          if (!data) this.showCardDialog();
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/pages/_landing.scss';

.app-points-container {
  display: flex;
  align-content: center;
  /* flex-wrap: wrap; */
  background: #f9f9f9;
  padding: 36px 8em;

  .welcome-text {
    flex: 0 35%;

    h1 {
      color: var(--color-primary);
      font-family: var(--font-family-secondary);
      font-size: 2.6em;
      font-weight: bold;
      text-align: right;
      letter-spacing: -0.02em;
    }
  }

  .auth-content {
    flex: 0 65%;
    padding-left: 80px;
  }
}

@media(max-width: 992px) {
  .app-points-container {
    padding: 2em !important;
    flex-direction: column;

    .welcome-text {
      width: 100%;
      flex: auto;

      h1 {
        text-align: left;
      }
    }

    .auth-content {
      margin-top: 1em;
      padding: 0 !important;
    }
  }
}
</style>
